var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"elevation-tab",style:(_vm.style)},[_c('Icon',{staticClass:"icon",attrs:{"icon":_vm.icon}}),_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }